import { IntegrationsPortErrors } from 'modules/Integrations/domain'
import type { AnrokIntegrationConfig } from './anrok.integration.config'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'

export const anrokConfigurationLoader = async (): Promise<{
  data: AnrokIntegrationConfig | null
  error: IntegrationsPortErrors | null
}> => {
  const result = await dashboardv99990101Client.getStoredAnrokCredentials()

  if (result.error) {
    return {
      data: {
        obfuscatedApiKey: ''
      },
      error: null
    }
  }

  return {
    data: {
      obfuscatedApiKey: result.data?.obfuscatedApiKey ?? ''
    },
    error: null
  }
}
